import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b2c6d75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "join-page" }
const _hoisted_2 = { class: "join-topbar" }
const _hoisted_3 = { class: "join-topbar__inner" }
const _hoisted_4 = { class: "join-topbar__org" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "join-topbar__orgname" }
const _hoisted_7 = {
  key: 0,
  class: "join-topbar__greeting"
}
const _hoisted_8 = {
  key: 0,
  class: "join-player"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "join-main"
}
const _hoisted_11 = {
  key: 0,
  class: "join-notfound"
}
const _hoisted_12 = {
  key: 1,
  class: "join-hero"
}
const _hoisted_13 = { class: "join-hero__info" }
const _hoisted_14 = { class: "join-hero__category" }
const _hoisted_15 = { class: "join-hero__title" }
const _hoisted_16 = { class: "join-hero__desc" }
const _hoisted_17 = { class: "join-hero__meta" }
const _hoisted_18 = { class: "join-hero__meta-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "12 6 12 12 16 14" })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "join-hero__meta-item" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.5"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M12 20h9" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" })
  ]),
  /*#__PURE__*/_createTextVNode(" Online-Fortbildung ")
], -1))
const _hoisted_21 = { class: "join-hero__actions" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "join-completed-badge" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2.5"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 6L9 17l-5-5" })
  ]),
  /*#__PURE__*/_createTextVNode(" Kurs abgeschlossen ")
], -1))
const _hoisted_23 = { class: "join-hero__completed-text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 12h14M12 5l7 7-7 7" })
], -1))
const _hoisted_26 = { class: "join-hero__visual" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M20 6L9 17l-5-5" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "22 4 12 14.01 9 11.01" }, null, -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';

type Step = 'landing' | 'playing' | 'completed';

export default /*#__PURE__*/_defineComponent({
  __name: 'JoinView',
  setup(__props) {

const route = useRoute();

// TODO: echten API-Call GET /public/join/:token implementieren
// Derzeit keine aktiven Einladungslinks — resolved ist immer null
const resolved = computed(() => null as null);
const org = computed(() => resolved.value?.org ?? null);
const course = computed(() => resolved.value?.course ?? null);
const user = computed(() => resolved.value?.user ?? null);

const step = ref<Step>('landing');
const courseIframe = ref<HTMLIFrameElement | null>(null);

// ── SCORM 1.2 API-Stub ────────────────────────────────────────────────────
function installScormApi() {
  (window as any).API = {
    LMSInitialize: () => 'true',
    LMSFinish: () => 'true',
    LMSGetValue: () => '',
    LMSSetValue: (key: string, value: string) => {
      if (key === 'cmi.core.lesson_status' && (value === 'passed' || value === 'completed')) {
        step.value = 'completed';
      }
      return 'true';
    },
    LMSCommit: () => 'true',
    LMSGetLastError: () => '0',
    LMSGetErrorString: () => 'No Error',
    LMSGetDiagnostic: () => 'No Error',
  };
}

function onIframeLoad() {
  const iframe = courseIframe.value;
  if (!iframe?.contentDocument) return;
  const doc = iframe.contentDocument;

  // ── CSS: Layout + Buttons in Brand-Farben ────────────────────────────
  const style = doc.createElement('style');
  style.textContent = `
    body, #root { background-color: #ffffff !important; }

    button[aria-label="Enter Fullscreen"],
    button[aria-label="Exit Fullscreen"] { display: none !important; }

    @media (min-width: 769px) {
      button[aria-label="Close navigation sidebar"] { display: none !important; }
      nav[aria-label="Sidebar"] { display: none !important; }
    }

    /* Continue / Weiter – primärer CTA */
    button[data-meda="continue"] {
      background-color: #0D5295 !important;
      border-color: #0D5295 !important;
      color: #ffffff !important;
      font-weight: 600 !important;
      padding: 10px 28px !important;
      border-radius: 8px !important;
      transition: background-color 150ms ease !important;
    }
    button[data-meda="continue"]:hover {
      background-color: #2790C9 !important;
      border-color: #2790C9 !important;
    }

    /* Back / Zurück – sekundär */
    button[data-meda="back"] {
      background-color: transparent !important;
      border: 2px solid #0D5295 !important;
      color: #0D5295 !important;
      font-weight: 600 !important;
      padding: 10px 28px !important;
      border-radius: 8px !important;
      transition: background-color 150ms ease !important;
    }
    button[data-meda="back"]:hover {
      background-color: #E7F0F7 !important;
    }
  `;
  doc.head.appendChild(style);

  // ── JS: Button-Text eingedeutscht + data-Attribut für CSS-Hook ───────
  const TRANSLATIONS: Record<string, { de: string; attr: string }> = {
    'continue': { de: 'Weiter',  attr: 'continue' },
    'next':     { de: 'Weiter',  attr: 'continue' },
    'back':     { de: 'Zurück',  attr: 'back'     },
    'previous': { de: 'Zurück',  attr: 'back'     },
  };

  function translateButtons() {
    doc.querySelectorAll('button').forEach((btn) => {
      const text = btn.textContent?.trim().toLowerCase() ?? '';
      const match = TRANSLATIONS[text];
      if (match) {
        btn.textContent = match.de;
        btn.setAttribute('data-meda', match.attr);
      }
    });
  }

  // Sofort versuchen + Observer für nachgeladene React-Komponenten
  translateButtons();
  const observer = new MutationObserver(translateButtons);
  observer.observe(doc.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 30_000);
}

function startCourse() {
  installScormApi();
  step.value = 'playing';
}

onBeforeUnmount(() => {
  delete (window as any).API;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(org)?.logoSvg)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "join-topbar__logo",
                innerHTML: _unref(org).logoSvg
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(org)?.name), 1)
        ]),
        (_unref(user))
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
              _createTextVNode(" Hallo, "),
              _createElementVNode("strong", null, _toDisplayString(_unref(user).name), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (step.value === 'playing')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("iframe", {
            ref_key: "courseIframe",
            ref: courseIframe,
            src: _unref(course)?.lms_path,
            frameborder: "0",
            allow: "autoplay; fullscreen",
            class: "join-player__iframe",
            onLoad: onIframeLoad
          }, null, 40, _hoisted_9)
        ]))
      : (_openBlock(), _createElementBlock("main", _hoisted_10, [
          (!_unref(resolved))
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Dieser Link ist nicht mehr gültig oder wurde bereits verwendet. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(course).category), 1),
                  _createElementVNode("h1", _hoisted_15, _toDisplayString(_unref(course).title), 1),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(course).description), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(_unref(course).duration_minutes) + " Minuten ", 1)
                    ]),
                    _hoisted_20
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (step.value === 'completed')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_22,
                          _createElementVNode("p", _hoisted_23, [
                            _createTextVNode(" Herzlichen Glückwunsch, "),
                            _createElementVNode("strong", null, _toDisplayString(_unref(user)?.name), 1),
                            _createTextVNode("!"),
                            _hoisted_24,
                            _createTextVNode(" Ihre Teilnahme wurde erfolgreich dokumentiert. ")
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn-start",
                          onClick: startCourse
                        }, [
                          _createTextVNode(" Kurs starten "),
                          _hoisted_25
                        ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("img", {
                    src: _unref(course)?.image,
                    alt: _unref(course)?.title,
                    class: "join-hero__image"
                  }, null, 8, _hoisted_27),
                  _createElementVNode("div", {
                    class: _normalizeClass(["join-hero__image-badge", { 'join-hero__image-badge--done': step.value === 'completed' }])
                  }, [
                    (step.value === 'completed')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_30))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_31, _hoisted_34)),
                    _createTextVNode(" " + _toDisplayString(step.value === 'completed' ? 'Abgeschlossen' : 'Zertifizierte Fortbildung'), 1)
                  ], 2)
                ])
              ]))
        ]))
  ]))
}
}

})